import { render, staticRenderFns } from "./Tag.vue?vue&type=template&id=7f6f6156&scoped=true"
import script from "./Tag.vue?vue&type=script&lang=ts"
export * from "./Tag.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./Tag.vue?vue&type=style&index=0&id=7f6f6156&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "7f6f6156",
  "a2f3c426"
  
)

export default component.exports